<template>
    <v-navigation-drawer v-model="showNav" app clipped persistent right style="background-color:#fafafc" >
        <v-toolbar color="#fafafc">
            <v-toolbar-title>
                Notes
            </v-toolbar-title>
        </v-toolbar>
        <div ref="chatScroll" v-if="request" flat class="messages scroll-y" style="background-color: transparent">
          <v-layout row v-for="(log, index) in request.log" :key="index" >
          <v-card flat style="width:100%;" :class="alternatingColors(index)" tile>
            <v-card-text>
              <div style="font-size:10px;">{{parseTimestamp(log.timestamp)}}</div>
              <div style="overflow-wrap: break-word; font-size:12px;">{{log.message}}</div>
          </v-card-text>
          </v-card>
        </v-layout>
        </div>
        <v-card  tile style="width: 100%; bottom: 0; left:0; position: absolute; border-top:1px solid #f5f5f5" color="transparent">
          <v-textarea outline solo class="px-2 mt-2" style="font-size:12px;" v-model="logEntryInput" @keyup.enter="submitLogEntry" hide-details auto-grow flat>
          </v-textarea>
            <v-layout column>
            <v-btn @click="submitLogEntry" dark depressed color="blue">
              
              <v-progress-circular indeterminate color="white" size="14" :width="2" v-if="updatingLog"/>
              <span v-else>Submit Note</span>
            </v-btn>
            </v-layout>
        </v-card>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import dateFormat from 'date-fns/format'
import bus from '@/core/helpers/bus'
import HelperMixin from '@/core/mixins/HelperMixin'

export default {
  mixins: [HelperMixin],
  methods: {
    ...mapActions('admin', [
      'getPatientList',
      'getUserList',
      'getRequest',
      'getRequestProvider',
      'setStatus',
      'sendRequest',
      'getRequestOverrides',
      'submitRequestOverrides',
      'submitRequestNote',
      'getDocumentFiles'
    ]),
    pullRequest() {
      let vm = this
      vm.getRequest(vm.$route.params.id).then(() => {
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight
      })
    },
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    submitLogEntry() {
      this.updatingLog = true
      let email = ''
      if (this.user) {
        if (this.user.email) {
          email = '(' + this.user.email + ')'
        }
      }
      let unix = Math.round(+new Date() / 1000)
      if (this.logEntryInput !== '' && this.logEntryInput !== null) {
        this.submitRequestNote({
          id: this.$route.params.id,
          notes: this.request.log,
          note: { timestamp: unix, message: this.logEntryInput + ' ' + email }
        }).then(data => {
          this.updatingLog = false
          this.logEntryInput = null
          this.publicNote = false
          this.getRequest(this.$route.params.id)
          this.toast('success', 'Note submitted')
          let vm = this
          vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight
        })
      } else {
        this.updatingLog = false
        this.toast('error', 'Note not submitted')
      }
    },
    parseTimestamp(timestamp) {
      const ts = new Date(parseInt(timestamp) * 1000)
      return dateFormat(ts, 'MMM D YYYY HH:MM:ss Z')
    },
    alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate'
      } else {
        return 'grayAlternate'
      }
    }
  },
  data() {
    return {
      logEntryInput: null,
      updatingLog: false,
      showNav: false
    }
  },
  watch: {
    $route(val) {
      console.log(val)
    },
    request(val) {
      console.log('request is back')
      if (val && this.$refs.chatScroll) {
        let vm = this
        vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight
      }
    }
  },
  computed: {
    ...mapState('admin', [
      'patientSearchResults',
      'userSearchResults',
      'request',
      'files'
    ]),
    ...mapState('auth', ['user'])
  },
  mounted() {
    const vm = this
    vm.getRequest(this.$route.params.id).then(() => {
      vm.$refs.chatScroll.scrollTop = vm.$refs.chatScroll.scrollHeight
      this.showNav = true
    })
  }
}
</script>

<style>
.messages {
  height: calc(100vh - 256px);
  width: 100%;
}
.grayAlternate {
  background-color: #ffffff;
}
.whiteAlternate {
  background-color: #fafafc;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestLogs.vue